<template>
  <div class="w-full">
    <!-- 校验按钮 -->
    <div class="w-full mt-4 px-4">
      <a-button
        class="!w-full !bg-white !text-black !font-bold !text-base"
        type="block"
        :loading="loading"
        @click="valid"
      >
        开始校验
      </a-button>
    </div>
    <div class="valid-res"></div>

    <!-- 校验规则 -->
    <div class="mt-2.5 text-[14px] bg-black-active p-4 pt-1 rounded-lg">
      <h3>息屏规范参考:</h3>
      <div class="flex flex-col gap-[6px] opacity-80">
        <div v-for="(ruleDesc, index) in ruleDescArr" :key="index">
          <div class="flex items-center flex-wrap">
            <template v-if="ruleDesc.tooltip && ruleDesc.desc.includes(': ')">
              <span>{{ index + 1 }}：{{ ruleDesc.desc.split(': ')[0] }}</span>
              <a-tooltip :title="ruleDesc.tooltip">
                <icon class="ml-0.5 mr-0.5 !cursor-default" icon="help.svg" :width="14" :height="14" fill="none" />
              </a-tooltip>
              <span>: {{ ruleDesc.desc.split(': ').slice(1).join(': ') }}；</span>
            </template>
            <template v-else>
              <div>{{ index + 1 }}：</div>
              <div>{{ ruleDesc.desc }}；</div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { AodThemeValidRse, useWatchfaceAodPixel } from '@/hooks';
import { useEditorStore } from '@/store/use-editor-store';

const editorStore = useEditorStore();
const { ruleDescArr, validAODPixels } = useWatchfaceAodPixel();
const loading = ref(false);
const validRes = ref<AodThemeValidRse[]>();
const valid = async () => {
  try {
    loading.value = true;
    validRes.value = (await validAODPixels())?.details.filter(
      (item) =>
        item.themeId == editorStore.themeId &&
        item.colorId == editorStore.themeColorId
    );
  } catch (error) {
    console.log(error);
    validRes.value = [];
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped></style>
